/* Employees */
export const EMPLOYEES_GET_REQUEST = "GET_EMPLOYEES_REQUEST";
export const EMPLOYEES_GET_SUCCESS = "GET_EMPLOYEES_SUCCESS";
export const EMPLOYEES_GET_ERROR = "GET_EMPLOYEES_ERROR";

export const EMPLOYEES_FACE_GET_REQUEST = "EMPLOYEES_FACE_GET_REQUEST";
export const EMPLOYEES_FACE_GET_SUCCESS = "EMPLOYEES_FACE_GET_SUCCESS";
export const EMPLOYEES_FACE_GET_ERROR = "EMPLOYEES_FACE_GET_ERROR";


/*Ats Employees */
export const ATS_EMPLOYEES_GET_REQUEST = "GET_ATS_EMPLOYEES_REQUEST";
export const ATS_EMPLOYEES_GET_SUCCESS = "GET_ATS_EMPLOYEES_SUCCESS";
export const ATS_EMPLOYEES_GET_ERROR = "GET_ATS_EMPLOYEES_ERROR";


/* Employee Basic Details */
export const GET_EMPLOYEE_BASIC_REQUEST = "GET_EMPLOYEE_BASIC_REQUEST";
export const GET_EMPLOYEE_BASIC_SUCCESS = "GET_EMPLOYEE_BASIC_SUCCESS";
export const GET_EMPLOYEE_BASIC_ERROR = "GET_EMPLOYEE_BASIC_ERROR";

export const UPDATE_EMPLOYEE_BASIC_REQUEST = "UPDATE_EMPLOYEE_BASIC_REQUEST";
export const UPDATE_EMPLOYEE_BASIC_SUCCESS = "UPDATE_EMPLOYEE_BASIC_SUCCESS";
export const UPDATE_EMPLOYEE_BASIC_ERROR = "UPDATE_EMPLOYEE_BASIC_ERROR";

export const ADD_EMPLOYEE_BASIC_REQUEST = "ADD_EMPLOYEE_BASIC_REQUEST";
export const ADD_EMPLOYEE_BASIC_SUCCESS = "ADD_EMPLOYEE_BASIC_SUCCESS";
export const ADD_EMPLOYEE_BASIC_ERROR = "ADD_EMPLOYEE_BASIC_ERROR";

/* Employee Bank Details */
export const GET_EMPLOYEE_BANK_REQUEST = "GET_EMPLOYEE_BANK_REQUEST";
export const GET_EMPLOYEE_BANK_SUCCESS = "GET_EMPLOYEE_BANK_SUCCESS";
export const GET_EMPLOYEE_BANK_ERROR = "GET_EMPLOYEE_BANK_ERROR";

export const ADD_EMPLOYEE_BANK_REQUEST = "ADD_EMPLOYEE_BANK_REQUEST";
export const ADD_EMPLOYEE_BANK_SUCCESS = "ADD_EMPLOYEE_BANK_SUCCESS";
export const ADD_EMPLOYEE_BANK_ERROR = "ADD_EMPLOYEE_BANK_ERROR";

export const UPDATE_EMPLOYEE_BANK_REQUEST = "UPDATE_EMPLOYEE_BANK_REQUEST";
export const UPDATE_EMPLOYEE_BANK_SUCCESS = "UPDATE_EMPLOYEE_BANK_SUCCESS";
export const UPDATE_EMPLOYEE_BANK_ERROR = "UPDATE_EMPLOYEE_BANK_ERROR";

export const DELETE_EMPLOYEE_BANK_REQUEST = "DELETE_EMPLOYEE_BANK_REQUEST";
export const DELETE_EMPLOYEE_BANK_SUCCESS = "DELETE_EMPLOYEE_BANK_SUCCESS";
export const DELETE_EMPLOYEE_BANK_ERROR = "DELETE_EMPLOYEE_BANK_ERROR";

/* Employee Family Details */
export const EMPLOYEE_FAMILY_GET_REQUEST = "GET_EMPLOYEE_FAMILY_REQUEST";
export const EMPLOYEE_FAMILY_GET_SUCCESS = "GET_EMPLOYEE_FAMILY_SUCCESS";
export const EMPLOYEE_FAMILY_GET_ERROR = "GET_EMPLOYEE_FAMILY_ERROR";

export const EMPLOYEE_FAMILY_ADD_REQUEST = "ADD_EMPLOYEE_FAMILY_REQUEST";
export const EMPLOYEE_FAMILY_ADD_SUCCESS = "ADD_EMPLOYEE_FAMILY_SUCCESS";
export const EMPLOYEE_FAMILY_ADD_ERROR = "ADD_EMPLOYEE_FAMILY_ERROR";

export const EMPLOYEE_FAMILY_UPDATE_REQUEST = "UPDATE_EMPLOYEE_FAMILY_REQUEST";
export const EMPLOYEE_FAMILY_UPDATE_SUCCESS = "UPDATE_EMPLOYEE_FAMILY_SUCCESS";
export const EMPLOYEE_FAMILY_UPDATE_ERROR = "UPDATE_EMPLOYEE_FAMILY_ERROR";

export const EMPLOYEE_FAMILY_DELETE_REQUEST = "DELETE_EMPLOYEE_FAMILY_REQUEST";
export const EMPLOYEE_FAMILY_DELETE_SUCCESS = "DELETE_EMPLOYEE_FAMILY_SUCCESS";
export const EMPLOYEE_FAMILY_DELETE_ERROR = "DELETE_EMPLOYEE_FAMILY_ERROR";

/* Employee Education Details */
export const EMPLOYEE_EDUCATION_GET_REQUEST = "GET_EMPLOYEE_EDUCATION_REQUEST";
export const EMPLOYEE_EDUCATION_GET_SUCCESS = "GET_EMPLOYEE_EDUCATION_SUCCESS";
export const EMPLOYEE_EDUCATION_GET_ERROR = "GET_EMPLOYEE_EDUCATION_ERROR";

export const EMPLOYEE_EDUCATION_ADD_REQUEST = "ADD_EMPLOYEE_EDUCATION_REQUEST";
export const EMPLOYEE_EDUCATION_ADD_SUCCESS = "ADD_EMPLOYEE_EDUCATION_SUCCESS";
export const EMPLOYEE_EDUCATION_ADD_ERROR = "ADD_EMPLOYEE_EDUCATION_ERROR";

export const EMPLOYEE_EDUCATION_UPDATE_REQUEST = "UPDATE_EMPLOYEE_EDUCATION_REQUEST";
export const EMPLOYEE_EDUCATION_UPDATE_SUCCESS = "UPDATE_EMPLOYEE_EDUCATION_SUCCESS";
export const EMPLOYEE_EDUCATION_UPDATE_ERROR = "UPDATE_EMPLOYEE_EDUCATION_ERROR";

export const EMPLOYEE_EDUCATION_DELETE_REQUEST = "DELETE_EMPLOYEE_EDUCATION_REQUEST";
export const EMPLOYEE_EDUCATION_DELETE_SUCCESS = "DELETE_EMPLOYEE_EDUCATION_SUCCESS";
export const EMPLOYEE_EDUCATION_DELETE_ERROR = "DELETE_EMPLOYEE_EDUCATION_ERROR";

/* Employee Work Experience Details */
export const EMPLOYEE_WORK_EXPERIENCE_GET_REQUEST = "GET_EMPLOYEE_WORK_EXPERIENCE_REQUEST";
export const EMPLOYEE_WORK_EXPERIENCE_GET_SUCCESS = "GET_EMPLOYEE_WORK_EXPERIENCE_SUCCESS";
export const EMPLOYEE_WORK_EXPERIENCE_GET_ERROR = "GET_EMPLOYEE_WORK_EXPERIENCE_ERROR";

export const EMPLOYEE_WORK_EXPERIENCE_ADD_REQUEST = "ADD_EMPLOYEE_WORK_EXPERIENCE_REQUEST";
export const EMPLOYEE_WORK_EXPERIENCE_ADD_SUCCESS = "ADD_EMPLOYEE_WORK_EXPERIENCE_SUCCESS";
export const EMPLOYEE_WORK_EXPERIENCE_ADD_ERROR = "ADD_EMPLOYEE_WORK_EXPERIENCE_ERROR";

export const EMPLOYEE_WORK_EXPERIENCE_UPDATE_REQUEST = "UPDATE_EMPLOYEE_WORK_EXPERIENCE_REQUEST";
export const EMPLOYEE_WORK_EXPERIENCE_UPDATE_SUCCESS = "UPDATE_EMPLOYEE_WORK_EXPERIENCE_SUCCESS";
export const EMPLOYEE_WORK_EXPERIENCE_UPDATE_ERROR = "UPDATE_EMPLOYEE_WORK_EXPERIENCE_ERROR";

export const EMPLOYEE_WORK_EXPERIENCE_DELETE_REQUEST = "DELETE_EMPLOYEE_WORK_EXPERIENCE_REQUEST";
export const EMPLOYEE_WORK_EXPERIENCE_DELETE_SUCCESS = "DELETE_EMPLOYEE_WORK_EXPERIENCE_SUCCESS";
export const EMPLOYEE_WORK_EXPERIENCE_DELETE_ERROR = "DELETE_EMPLOYEE_WORK_EXPERIENCE_ERROR";

/* Employee Personal Details */
export const EMPLOYEE_PERSONAL_GET_REQUEST = "EMPLOYEE_PERSONAL_GET_REQUEST";
export const EMPLOYEE_PERSONAL_GET_SUCCESS = "EMPLOYEE_PERSONAL_GET_SUCCESS";

export const EMPLOYEE_PERSONAL_ADD_REQUEST = "EMPLOYEE_PERSONAL_ADD_REQUEST";
export const EMPLOYEE_PERSONAL_ADD_SUCCESS = "EMPLOYEE_PERSONAL_ADD_SUCCESS";
export const EMPLOYEE_PERSONAL_ADD_ERROR = "EMPLOYEE_PERSONAL_ADD_ERROR";

export const EMPLOYEE_PERSONAL_UPDATE_REQUEST = "EMPLOYEE_PERSONAL_UPDATE_REQUEST";
export const EMPLOYEE_PERSONAL_UPDATE_SUCCESS = "EMPLOYEE_PERSONAL_UPDATE_SUCCESS";
export const EMPLOYEE_PERSONAL_UPDATE_ERROR = "EMPLOYEE_PERSONAL_UPDATE_ERROR";

export const EMPLOYEE_PERSONAL_DELETE_REQUEST = "EMPLOYEE_PERSONAL_DELETE_REQUEST";
export const EMPLOYEE_PERSONAL_DELETE_SUCCESS = "EMPLOYEE_PERSONAL_DELETE_SUCCESS";
export const EMPLOYEE_PERSONAL_DELETE_ERROR = "EMPLOYEE_PERSONAL_DELETE_ERROR";

/* Employee Other Personal Details */
export const EMPLOYEE_OTHER_PERSONAL_GET_REQUEST = "EMPLOYEE_OTHER_PERSONAL_GET_REQUEST";
export const EMPLOYEE_OTHER_PERSONAL_GET_SUCCESS = "EMPLOYEE_OTHER_PERSONAL_GET_SUCCESS";

export const EMPLOYEE_OTHER_PERSONAL_UPDATE_REQUEST = "EMPLOYEE_OTHER_PERSONAL_UPDATE_REQUEST";
export const EMPLOYEE_OTHER_PERSONAL_UPDATE_SUCCESS = "EMPLOYEE_OTHER_PERSONAL_UPDATE_SUCCESS";
export const EMPLOYEE_OTHER_PERSONAL_UPDATE_ERROR = "EMPLOYEE_OTHER_PERSONAL_UPDATE_ERROR";

/* Employee Work  Details */
export const EMPLOYEE_WORK_DETAIL_GET_REQUEST = "GET_EMPLOYEE_WORK_DETAIL_REQUEST";
export const EMPLOYEE_WORK_DETAIL_GET_SUCCESS = "GET_EMPLOYEE_WORK_DETAIL_SUCCESS";
export const EMPLOYEE_WORK_DETAIL_GET_ERROR = "GET_EMPLOYEE_WORK_DETAIL_ERROR";

export const EMPLOYEE_WORK_DETAIL_UPDATE_REQUEST = "UPDATE_EMPLOYEE_WORK_DETAIL_REQUEST";
export const EMPLOYEE_WORK_DETAIL_UPDATE_SUCCESS = "UPDATE_EMPLOYEE_WORK_DETAIL_SUCCESS";
export const EMPLOYEE_WORK_DETAIL_UPDATE_ERROR = "UPDATE_EMPLOYEE_WORK_DETAIL_ERROR";

export const EMPLOYEE_WORK_DETAIL_ADD_REQUEST = "ADD_EMPLOYEE_WORK_DETAIL_REQUEST";
export const EMPLOYEE_WORK_DETAIL_ADD_SUCCESS = "ADD_EMPLOYEE_WORK_DETAIL_SUCCESS";
export const EMPLOYEE_WORK_DETAIL_ADD_ERROR = "ADD_EMPLOYEE_WORK_DETAIL_ERROR";


/* Employee Payroll Details */
export const GET_EMPLOYEE_PAYROLL_DETAILS_REQUEST = "GET_EMPLOYEE_PAYROLL_DETAILS_REQUEST";
export const GET_EMPLOYEE_PAYROLL_DETAILS_SUCCESS = "GET_EMPLOYEE_PAYROLL_DETAILS_SUCCESS";
export const GET_EMPLOYEE_PAYROLL_DETAILS_ERROR = "GET_EMPLOYEE_PAYROLL_DETAILS_ERROR";

export const UPDATE_EMPLOYEE_PAYROLL_DETAILS_REQUEST = "UPDATE_EMPLOYEE_PAYROLL_DETAILS_REQUEST";
export const UPDATE_EMPLOYEE_PAYROLL_DETAILS_SUCCESS = "UPDATE_EMPLOYEE_PAYROLL_DETAILS_SUCCESS";
export const UPDATE_EMPLOYEE_PAYROLL_DETAILS_ERROR = "UPDATE_EMPLOYEE_PAYROLL_DETAILS_ERROR";

export const EMPLOYEE_ADDRESS_UPDATE_REQUEST = "EMPLOYEE_ADDRESS_UPDATE_REQUEST";
export const EMPLOYEE_ADDRESS_UPDATE_SUCCESS = "EMPLOYEE_ADDRESS_UPDATE_SUCCESS";
export const EMPLOYEE_ADDRESS_UPDATE_ERROR = "EMPLOYEE_ADDRESS_UPDATE_ERROR";

export const EMPLOYEE_ADDRESS_GET_REQUEST = "EMPLOYEE_ADDRESS_GET_REQUEST";
export const EMPLOYEE_ADDRESS_GET_SUCCESS = "EMPLOYEE_ADDRESS_GET_SUCCESS";
export const EMPLOYEE_ADDRESS_GET_ERROR = "EMPLOYEE_ADDRESS_GET_ERROR";


/* Employee Payroll Profile  Details */
export const EMPLOYEE_PAYROLL_PROFILE_DETAIL_GET_REQUEST = "EMPLOYEE_PAYROLL_PROFILE_DETAIL_GET_REQUEST";
export const EMPLOYEE_PAYROLL_PROFILE_DETAIL_GET_SUCCESS = "EMPLOYEE_PAYROLL_PROFILE_DETAIL_GET_SUCCESS";
export const EMPLOYEE_PAYROLL_PROFILE_DETAIL_GET_ERROR = "EMPLOYEE_PAYROLL_PROFILE_DETAIL_GET_ERROR";

export const EMPLOYEE_PAYROLL_PROFILE_DETAIL_UPDATE_REQUEST = "EMPLOYEE_PAYROLL_PROFILE_DETAIL_UPDATE_REQUEST";
export const EMPLOYEE_PAYROLL_PROFILE_DETAIL_UPDATE_SUCCESS = "EMPLOYEE_PAYROLL_PROFILE_DETAIL_UPDATE_SUCCESS";
export const EMPLOYEE_PAYROLL_PROFILE_DETAIL_UPDATE_ERROR = "EMPLOYEE_PAYROLL_PROFILE_DETAIL_UPDATE_ERROR";

// For Getting Visitors and Visitors Reasong
export const VISITORS_GET_REQUEST = "VISITORS_GET_REQUEST";
export const VISITORS_GET_SUCCESS = "VISITORS_GET_SUCCESS";
export const VISITORS_GET_ERROR = "VISITORS_GET_ERROR";

export const VISITORS_DATA_GET_REQUEST = "VISITORS_DATA_GET_REQUEST";
export const VISITORS_DATA_GET_SUCCESS = "VISITORS_DATA_GET_SUCCESS";
export const VISITORS_DATA_GET_ERROR = "VISITORS_DATA_GET_ERROR";

export const ADD_VISITORS_REQUEST = "ADD_VISITORS_REQUEST";
export const ADD_VISITORS_SUCCESS = "ADD_VISITORS_SUCCESS";
export const ADD_VISITORS_ERROR = "ADD_VISITORS_ERROR";

export const UPDATE_VISITORS_REQUEST = "UPDATE_VISITORS_REQUEST";
export const UPDATE_VISITORS_SUCCESS = "UPDATE_VISITORS_SUCCESS";
export const UPDATE_VISITORS_ERROR = "UPDATE_VISITORS_ERROR";

export const UPDATE_BULK_VISITORS_REQUEST = "UPDATE_BULK_VISITORS_REQUEST";
export const UPDATE_BULK_VISITORS_SUCCESS = "UPDATE_BULK_VISITORS_SUCCESS";
export const UPDATE_BULK_VISITORS_ERROR = "UPDATE_BULK_VISITORS_ERROR";


export const GET_VISITORS_REASON_REQUEST = "GET_VISITORS_REASON_REQUEST";
export const GET_VISITORS_REASON_SUCCESS = "GET_VISITORS_REASON_SUCCESS";
export const GET_VISITORS_REASON_ERROR = "GET_VISITORS_REASON_ERROR";

// Visitor Management Reason Action Types
export const VISITOR_MANAGEMENT_REASON_GET_REQUEST = "VISITOR_MANAGEMENT_REASON_GET_REQUEST";
export const VISITOR_MANAGEMENT_REASON_GET_SUCCESS = "VISITOR_MANAGEMENT_REASON_GET_SUCCESS";
export const VISITOR_MANAGEMENT_REASON_GET_ERROR = "VISITOR_MANAGEMENT_REASON_GET_ERROR";

export const VISITOR_MANAGEMENT_REASON_ADD_REQUEST = "VISITOR_MANAGEMENT_REASON_ADD_REQUEST";
export const VISITOR_MANAGEMENT_REASON_ADD_SUCCESS = "VISITOR_MANAGEMENT_REASON_ADD_SUCCESS";
export const VISITOR_MANAGEMENT_REASON_ADD_ERROR = "VISITOR_MANAGEMENT_REASON_ADD_ERROR";

export const VISITOR_MANAGEMENT_REASON_UPDATE_REQUEST = "VISITOR_MANAGEMENT_REASON_UPDATE_REQUEST";
export const VISITOR_MANAGEMENT_REASON_UPDATE_SUCCESS = "VISITOR_MANAGEMENT_REASON_UPDATE_SUCCESS";
export const VISITOR_MANAGEMENT_REASON_UPDATE_ERROR = "VISITOR_MANAGEMENT_REASON_UPDATE_ERROR";

export const VISITOR_MANAGEMENT_REASON_DELETE_REQUEST = "VISITOR_MANAGEMENT_REASON_DELETE_REQUEST";
export const VISITOR_MANAGEMENT_REASON_DELETE_SUCCESS = "VISITOR_MANAGEMENT_REASON_DELETE_SUCCESS";
export const VISITOR_MANAGEMENT_REASON_DELETE_ERROR = "VISITOR_MANAGEMENT_REASON_DELETE_ERROR";

// Visitor Management Region Action Types
export const VISITOR_MANAGEMENT_REGION_GET_REQUEST = "VISITOR_MANAGEMENT_REGION_GET_REQUEST";
export const VISITOR_MANAGEMENT_REGION_GET_SUCCESS = "VISITOR_MANAGEMENT_REGION_GET_SUCCESS";
export const VISITOR_MANAGEMENT_REGION_GET_ERROR = "VISITOR_MANAGEMENT_REGION_GET_ERROR";

export const VISITOR_MANAGEMENT_REGION_ADD_REQUEST = "VISITOR_MANAGEMENT_REGION_ADD_REQUEST";
export const VISITOR_MANAGEMENT_REGION_ADD_SUCCESS = "VISITOR_MANAGEMENT_REGION_ADD_SUCCESS";
export const VISITOR_MANAGEMENT_REGION_ADD_ERROR = "VISITOR_MANAGEMENT_REGION_ADD_ERROR";

export const VISITOR_MANAGEMENT_REGION_UPDATE_REQUEST = "VISITOR_MANAGEMENT_REGION_UPDATE_REQUEST";
export const VISITOR_MANAGEMENT_REGION_UPDATE_SUCCESS = "VISITOR_MANAGEMENT_REGION_UPDATE_SUCCESS";
export const VISITOR_MANAGEMENT_REGION_UPDATE_ERROR = "VISITOR_MANAGEMENT_REGION_UPDATE_ERROR";

export const VISITOR_MANAGEMENT_REGION_DELETE_REQUEST = "VISITOR_MANAGEMENT_REGION_DELETE_REQUEST";
export const VISITOR_MANAGEMENT_REGION_DELETE_SUCCESS = "VISITOR_MANAGEMENT_REGION_DELETE_SUCCESS";
export const VISITOR_MANAGEMENT_REGION_DELETE_ERROR = "VISITOR_MANAGEMENT_REGION_DELETE_ERROR";

export const VM_EXTRA_SETTING_GET_REQUEST = "VM_EXTRA_SETTING_GET_REQUEST";
export const VM_EXTRA_SETTING_GET_SUCCESS = "VM_EXTRA_SETTING_GET_SUCCESS";
export const VM_EXTRA_SETTING_GET_ERROR = "VM_EXTRA_SETTING_GET_ERROR";

export const VM_EXTRA_SETTING_UPDATE_REQUEST = "VM_EXTRA_SETTING_UPDATE_REQUEST";
export const VM_EXTRA_SETTING_UPDATE_SUCCESS = "VM_EXTRA_SETTING_UPDATE_SUCCESS";
export const VM_EXTRA_SETTING_UPDATE_ERROR = "VM_EXTRA_SETTING_UPDATE_ERROR";

// PMS
export const MANAGE_GOAL_GET_REQUEST = "MANAGE_GOAL_GET_REQUEST";
export const MANAGE_GOAL_GET_SUCCESS = "MANAGE_GOAL_GET_SUCCESS";
export const MANAGE_GOAL_GET_ERROR = "MANAGE_GOAL_GET_ERROR";

export const MY_GOAL_GET_REQUEST = "MY_GOAL_GET_REQUEST";
export const MY_GOAL_GET_SUCCESS = "MY_GOAL_GET_SUCCESS";
export const MY_GOAL_GET_ERROR = "MY_GOAL_GET_ERROR";

export const MANAGE_GOAL_ADD_REQUEST = "MANAGE_GOAL_ADD_REQUEST";
export const MANAGE_GOAL_ADD_SUCCESS = "MANAGE_GOAL_ADD_SUCCESS";
export const MANAGE_GOAL_ADD_ERROR = "MANAGE_GOAL_ADD_ERROR";

export const MANAGE_GOAL_UPDATE_REQUEST = "MANAGE_GOAL_UPDATE_REQUEST";
export const MANAGE_GOAL_UPDATE_SUCCESS = "MANAGE_GOAL_UPDATE_SUCCESS";
export const MANAGE_GOAL_UPDATE_ERROR = "MANAGE_GOAL_UPDATE_ERROR";

export const MANAGE_GOAL_DELETE_REQUEST = "MANAGE_GOAL_DELETE_REQUEST";
export const MANAGE_GOAL_DELETE_SUCCESS = "MANAGE_GOAL_DELETE_SUCCESS";
export const MANAGE_GOAL_DELETE_ERROR = "MANAGE_GOAL_DELETE_ERROR";

export const PMS_FEEDBACK_GET_REQUEST = "PMS_FEEDBACK_GET_REQUEST";
export const PMS_FEEDBACK_GET_SUCCESS = "PMS_FEEDBACK_GET_SUCCESS";
export const PMS_FEEDBACK_GET_ERROR = "PMS_FEEDBACK_GET_ERROR";

export const PMS_FEEDBACK_ADD_REQUEST = "PMS_FEEDBACK_ADD_REQUEST";
export const PMS_FEEDBACK_ADD_SUCCESS = "PMS_FEEDBACK_ADD_SUCCESS";
export const PMS_FEEDBACK_ADD_ERROR = "PMS_FEEDBACK_ADD_ERROR";

export const PMS_FEEDBACK_UPDATE_REQUEST = "PMS_FEEDBACK_UPDATE_REQUEST";
export const PMS_FEEDBACK_UPDATE_SUCCESS = "PMS_FEEDBACK_UPDATE_SUCCESS";
export const PMS_FEEDBACK_UPDATE_ERROR = "PMS_FEEDBACK_UPDATE_ERROR";

export const PMS_FEEDBACK_DELETE_REQUEST = "PMS_FEEDBACK_DELETE_REQUEST";
export const PMS_FEEDBACK_DELETE_SUCCESS = "PMS_FEEDBACK_DELETE_SUCCESS";
export const PMS_FEEDBACK_DELETE_ERROR = "PMS_FEEDBACK_DELETE_ERROR";

export const GOAL_TYPE_GET_REQUEST = "GOAL_TYPE_GET_REQUEST";
export const GOAL_TYPE_GET_SUCCESS = "GOAL_TYPE_GET_SUCCESS";
export const GOAL_TYPE_GET_ERROR = "GOAL_TYPE_GET_ERROR";
export const GOAL_TYPE_ADD_REQUEST = "GOAL_TYPE_ADD_REQUEST";
export const GOAL_TYPE_ADD_SUCCESS = "GOAL_TYPE_ADD_SUCCESS";
export const GOAL_TYPE_ADD_ERROR = "GOAL_TYPE_ADD_ERROR";
export const GOAL_TYPE_UPDATE_REQUEST = "GOAL_TYPE_UPDATE_REQUEST";
export const GOAL_TYPE_UPDATE_SUCCESS = "GOAL_TYPE_UPDATE_SUCCESS";
export const GOAL_TYPE_UPDATE_ERROR = "GOAL_TYPE_UPDATE_ERROR";
export const GOAL_TYPE_DELETE_REQUEST = "GOAL_TYPE_DELETE_REQUEST";
export const GOAL_TYPE_DELETE_SUCCESS = "GOAL_TYPE_DELETE_SUCCESS";
export const GOAL_TYPE_DELETE_ERROR = "GOAL_TYPE_DELETE_ERROR";

export const GOAL_SUBTYPE_GET_REQUEST = "GOAL_SUBTYPE_GET_REQUEST";
export const GOAL_SUBTYPE_GET_SUCCESS = "GOAL_SUBTYPE_GET_SUCCESS";
export const GOAL_SUBTYPE_GET_ERROR = "GOAL_SUBTYPE_GET_ERROR";
export const GOAL_SUBTYPE_ADD_REQUEST = "GOAL_SUBTYPE_ADD_REQUEST";
export const GOAL_SUBTYPE_ADD_SUCCESS = "GOAL_SUBTYPE_ADD_SUCCESS";
export const GOAL_SUBTYPE_ADD_ERROR = "GOAL_SUBTYPE_ADD_ERROR";
export const GOAL_SUBTYPE_UPDATE_REQUEST = "GOAL_SUBTYPE_UPDATE_REQUEST";
export const GOAL_SUBTYPE_UPDATE_SUCCESS = "GOAL_SUBTYPE_UPDATE_SUCCESS";
export const GOAL_SUBTYPE_UPDATE_ERROR = "GOAL_SUBTYPE_UPDATE_ERROR";
export const GOAL_SUBTYPE_DELETE_REQUEST = "GOAL_SUBTYPE_DELETE_REQUEST";
export const GOAL_SUBTYPE_DELETE_SUCCESS = "GOAL_SUBTYPE_DELETE_SUCCESS";
export const GOAL_SUBTYPE_DELETE_ERROR = "GOAL_SUBTYPE_DELETE_ERROR";
export const GET_ECMS_EXIT_REASON_REQUEST = "GET_ECMS_EXIT_REASON_REQUEST";
export const GET_ECMS_EXIT_REASON_SUCCESS = "GET_ECMS_EXIT_REASON_SUCCESS";
export const GET_ECMS_EXIT_REASON_ERROR   = "GET_ECMS_EXIT_REASON_ERROR";

export const PERFORMANCE_LOG_GET_REQUEST = "PERFORMANCE_LOG_GET_REQUEST";
export const PERFORMANCE_LOG_GET_SUCCESS = "PERFORMANCE_LOG_GET_SUCCESS";
export const PERFORMANCE_LOG_GET_ERROR = "PERFORMANCE_LOG_GET_ERROR";

export const PERFORMANCE_LOG_ADD_REQUEST = "PERFORMANCE_LOG_ADD_REQUEST";
export const PERFORMANCE_LOG_ADD_SUCCESS = "PERFORMANCE_LOG_ADD_SUCCESS";
export const PERFORMANCE_LOG_ADD_ERROR = "PERFORMANCE_LOG_ADD_ERROR";

export const PERFORMANCE_LOG_UPDATE_REQUEST = "PERFORMANCE_LOG_UPDATE_REQUEST";
export const PERFORMANCE_LOG_UPDATE_SUCCESS = "PERFORMANCE_LOG_UPDATE_SUCCESS";
export const PERFORMANCE_LOG_UPDATE_ERROR = "PERFORMANCE_LOG_UPDATE_ERROR";

export const PERFORMANCE_LOG_DELETE_REQUEST = "PERFORMANCE_LOG_DELETE_REQUEST";
export const PERFORMANCE_LOG_DELETE_SUCCESS = "PERFORMANCE_LOG_DELETE_SUCCESS";
export const PERFORMANCE_LOG_DELETE_ERROR = "PERFORMANCE_LOG_DELETE_ERROR";


export const ADD_ECMS_EXIT_REASON_REQUEST = "ADD_ECMS_EXIT_REASON_REQUEST";
export const ADD_ECMS_EXIT_REASON_SUCCESS = "ADD_ECMS_EXIT_REASON_SUCCESS";
export const ADD_ECMS_EXIT_REASON_ERROR   = "ADD_ECMS_EXIT_REASON_ERROR";

export const UPDATE_ECMS_EXIT_REASON_REQUEST = "UPDATE_ECMS_EXIT_REASON_REQUEST";
export const UPDATE_ECMS_EXIT_REASON_SUCCESS = "UPDATE_ECMS_EXIT_REASON_SUCCESS";
export const UPDATE_ECMS_EXIT_REASON_ERROR   = "UPDATE_ECMS_EXIT_REASON_ERROR";

export const DELETE_ECMS_EXIT_REASON_REQUEST = "DELETE_ECMS_EXIT_REASON_REQUEST";
export const DELETE_ECMS_EXIT_REASON_SUCCESS = "DELETE_ECMS_EXIT_REASON_SUCCESS";
export const DELETE_ECMS_EXIT_REASON_ERROR   = "DELETE_ECMS_EXIT_REASON_ERROR";

export const GET_ECMS_CLEARANCE_TYPE_REQUEST = "GET_ECMS_CLEARANCE_TYPE_REQUEST";
export const GET_ECMS_CLEARANCE_TYPE_SUCCESS = "GET_ECMS_CLEARANCE_TYPE_SUCCESS";
export const GET_ECMS_CLEARANCE_TYPE_ERROR   = "GET_ECMS_CLEARANCE_TYPE_ERROR";

export const ADD_ECMS_CLEARANCE_TYPE_REQUEST = "ADD_ECMS_CLEARANCE_TYPE_REQUEST";
export const ADD_ECMS_CLEARANCE_TYPE_SUCCESS = "ADD_ECMS_CLEARANCE_TYPE_SUCCESS";
export const ADD_ECMS_CLEARANCE_TYPE_ERROR   = "ADD_ECMS_CLEARANCE_TYPE_ERROR";

export const UPDATE_ECMS_CLEARANCE_TYPE_REQUEST = "UPDATE_ECMS_CLEARANCE_TYPE_REQUEST";
export const UPDATE_ECMS_CLEARANCE_TYPE_SUCCESS = "UPDATE_ECMS_CLEARANCE_TYPE_SUCCESS";
export const UPDATE_ECMS_CLEARANCE_TYPE_ERROR   = "UPDATE_ECMS_CLEARANCE_TYPE_ERROR";

export const DELETE_ECMS_CLEARANCE_TYPE_REQUEST = "DELETE_ECMS_CLEARANCE_TYPE_REQUEST";
export const DELETE_ECMS_CLEARANCE_TYPE_SUCCESS = "DELETE_ECMS_CLEARANCE_TYPE_SUCCESS";
export const DELETE_ECMS_CLEARANCE_TYPE_ERROR   = "DELETE_ECMS_CLEARANCE_TYPE_ERROR";

export const EMPLOYEE_CLEARANCE_GET_REQUEST = "EMPLOYEE_CLEARANCE_GET_REQUEST";
export const EMPLOYEE_CLEARANCE_GET_SUCCESS = "EMPLOYEE_CLEARANCE_GET_SUCCESS";
export const EMPLOYEE_CLEARANCE_GET_ERROR   = "EMPLOYEE_CLEARANCE_GET_ERROR";

export const EMPLOYEE_CLEARANCE_ADD_REQUEST = "EMPLOYEE_CLEARANCE_ADD_REQUEST";
export const EMPLOYEE_CLEARANCE_ADD_SUCCESS = "EMPLOYEE_CLEARANCE_ADD_SUCCESS";
export const EMPLOYEE_CLEARANCE_ADD_ERROR   = "EMPLOYEE_CLEARANCE_ADD_ERROR";

export const EMPLOYEE_CLEARANCE_UPDATE_REQUEST = "EMPLOYEE_CLEARANCE_UPDATE_REQUEST";
export const EMPLOYEE_CLEARANCE_UPDATE_SUCCESS = "EMPLOYEE_CLEARANCE_UPDATE_SUCCESS";
export const EMPLOYEE_CLEARANCE_UPDATE_ERROR   = "EMPLOYEE_CLEARANCE_UPDATE_ERROR";

export const EMPLOYEE_CLEARANCE_DELETE_REQUEST = "EMPLOYEE_CLEARANCE_DELETE_REQUEST";
export const EMPLOYEE_CLEARANCE_DELETE_SUCCESS = "EMPLOYEE_CLEARANCE_DELETE_SUCCESS";
export const EMPLOYEE_CLEARANCE_DELETE_ERROR   = "EMPLOYEE_CLEARANCE_DELETE_ERROR";

export const ECMS_ADMIN_EXIT_EMPLOYEE_GET_REQUEST = "ECMS_ADMIN_EXIT_EMPLOYEE_GET_REQUEST";
export const ECMS_ADMIN_EXIT_EMPLOYEE_GET_SUCCESS = "ECMS_ADMIN_EXIT_EMPLOYEE_GET_SUCCESS";
export const ECMS_ADMIN_EXIT_EMPLOYEE_GET_ERROR   = "ECMS_ADMIN_EXIT_EMPLOYEE_GET_ERROR";

export const EMPLOYEE_CANTEEN_TOKEN_GET_REQUEST = "EMPLOYEE_CANTEEN_TOKEN_GET_REQUEST";
export const EMPLOYEE_CANTEEN_TOKEN_GET_SUCCESS = "EMPLOYEE_CANTEEN_TOKEN_GET_SUCCESS";
export const EMPLOYEE_CANTEEN_TOKEN_GET_ERROR   = "EMPLOYEE_CANTEEN_TOKEN_GET_ERROR";

export const EMPLOYEE_CANTEEN_TOKEN_ADD_REQUEST = "EMPLOYEE_CANTEEN_TOKEN_ADD_REQUEST";
export const EMPLOYEE_CANTEEN_TOKEN_ADD_SUCCESS = "EMPLOYEE_CANTEEN_TOKEN_ADD_SUCCESS";
export const EMPLOYEE_CANTEEN_TOKEN_ADD_ERROR   = "EMPLOYEE_CANTEEN_TOKEN_ADD_ERROR";

export const EMPLOYEE_CANTEEN_TOKEN_UPDATE_REQUEST = "EMPLOYEE_CANTEEN_TOKEN_UPDATE_REQUEST";
export const EMPLOYEE_CANTEEN_TOKEN_UPDATE_SUCCESS = "EMPLOYEE_CANTEEN_TOKEN_UPDATE_SUCCESS";
export const EMPLOYEE_CANTEEN_TOKEN_UPDATE_ERROR   = "EMPLOYEE_CANTEEN_TOKEN_UPDATE_ERROR";

export const EMPLOYEE_CANTEEN_TOKEN_DELETE_REQUEST = "EMPLOYEE_CANTEEN_TOKEN_DELETE_REQUEST";
export const EMPLOYEE_CANTEEN_TOKEN_DELETE_SUCCESS = "EMPLOYEE_CANTEEN_TOKEN_DELETE_SUCCESS";
export const EMPLOYEE_CANTEEN_TOKEN_DELETE_ERROR   = "EMPLOYEE_CANTEEN_TOKEN_DELETE_ERROR";

// CANTEEN Management Region Action Types
export const CANTEEN_MANAGEMENT_REGION_GET_REQUEST = "CANTEEN_MANAGEMENT_REGION_GET_REQUEST";
export const CANTEEN_MANAGEMENT_REGION_GET_SUCCESS = "CANTEEN_MANAGEMENT_REGION_GET_SUCCESS";
export const CANTEEN_MANAGEMENT_REGION_GET_ERROR = "CANTEEN_MANAGEMENT_REGION_GET_ERROR";

export const CANTEEN_MANAGEMENT_REGION_ADD_REQUEST = "CANTEEN_MANAGEMENT_REGION_ADD_REQUEST";
export const CANTEEN_MANAGEMENT_REGION_ADD_SUCCESS = "CANTEEN_MANAGEMENT_REGION_ADD_SUCCESS";
export const CANTEEN_MANAGEMENT_REGION_ADD_ERROR = "CANTEEN_MANAGEMENT_REGION_ADD_ERROR";

export const CANTEEN_MANAGEMENT_REGION_UPDATE_REQUEST = "CANTEEN_MANAGEMENT_REGION_UPDATE_REQUEST";
export const CANTEEN_MANAGEMENT_REGION_UPDATE_SUCCESS = "CANTEEN_MANAGEMENT_REGION_UPDATE_SUCCESS";
export const CANTEEN_MANAGEMENT_REGION_UPDATE_ERROR = "CANTEEN_MANAGEMENT_REGION_UPDATE_ERROR";

export const CANTEEN_MANAGEMENT_REGION_DELETE_REQUEST = "CANTEEN_MANAGEMENT_REGION_DELETE_REQUEST";
export const CANTEEN_MANAGEMENT_REGION_DELETE_SUCCESS = "CANTEEN_MANAGEMENT_REGION_DELETE_SUCCESS";
export const CANTEEN_MANAGEMENT_REGION_DELETE_ERROR = "CANTEEN_MANAGEMENT_REGION_DELETE_ERROR";

// VM Org Type (single/multiple toggle)
export const VM_ORG_TYPE_GET_REQUEST = "VM_ORG_TYPE_GET_REQUEST";
export const VM_ORG_TYPE_GET_SUCCESS = "VM_ORG_TYPE_GET_SUCCESS";
export const VM_ORG_TYPE_GET_ERROR = "VM_ORG_TYPE_GET_ERROR";

export const VM_ORG_TYPE_UPDATE_REQUEST = "VM_ORG_TYPE_UPDATE_REQUEST";
export const VM_ORG_TYPE_UPDATE_SUCCESS = "VM_ORG_TYPE_UPDATE_SUCCESS";
export const VM_ORG_TYPE_UPDATE_ERROR = "VM_ORG_TYPE_UPDATE_ERROR";

// VM Multiple Org Configuration
export const VM_MULTIPLE_ORG_GET_REQUEST = "VM_MULTIPLE_ORG_GET_REQUEST";
export const VM_MULTIPLE_ORG_GET_SUCCESS = "VM_MULTIPLE_ORG_GET_SUCCESS";
export const VM_MULTIPLE_ORG_GET_ERROR = "VM_MULTIPLE_ORG_GET_ERROR";

export const VM_MULTIPLE_ORG_UPSERT_REQUEST = "VM_MULTIPLE_ORG_UPSERT_REQUEST";
export const VM_MULTIPLE_ORG_UPSERT_SUCCESS = "VM_MULTIPLE_ORG_UPSERT_SUCCESS";
export const VM_MULTIPLE_ORG_UPSERT_ERROR = "VM_MULTIPLE_ORG_UPSERT_ERROR";

export const VM_MULTIPLE_ORG_DELETE_REQUEST = "VM_MULTIPLE_ORG_DELETE_REQUEST";
export const VM_MULTIPLE_ORG_DELETE_SUCCESS = "VM_MULTIPLE_ORG_DELETE_SUCCESS";
export const VM_MULTIPLE_ORG_DELETE_ERROR = "VM_MULTIPLE_ORG_DELETE_ERROR";

// VM Pre-Registration
export const VM_PRE_REGISTRATION_GET_REQUEST = "VM_PRE_REGISTRATION_GET_REQUEST";
export const VM_PRE_REGISTRATION_GET_SUCCESS = "VM_PRE_REGISTRATION_GET_SUCCESS";
export const VM_PRE_REGISTRATION_GET_ERROR = "VM_PRE_REGISTRATION_GET_ERROR";

export const VM_PRE_REGISTRATION_UPSERT_REQUEST = "VM_PRE_REGISTRATION_UPSERT_REQUEST";
export const VM_PRE_REGISTRATION_UPSERT_SUCCESS = "VM_PRE_REGISTRATION_UPSERT_SUCCESS";
export const VM_PRE_REGISTRATION_UPSERT_ERROR = "VM_PRE_REGISTRATION_UPSERT_ERROR";

export const VM_PRE_REGISTRATION_DELETE_REQUEST = "VM_PRE_REGISTRATION_DELETE_REQUEST";
export const VM_PRE_REGISTRATION_DELETE_SUCCESS = "VM_PRE_REGISTRATION_DELETE_SUCCESS";
export const VM_PRE_REGISTRATION_DELETE_ERROR = "VM_PRE_REGISTRATION_DELETE_ERROR";

export const GET_EAC_USER_REQUEST = "GET_EAC_USER_REQUEST";
export const GET_EAC_USER_SUCCESS = "GET_EAC_USER_SUCCESS";
export const GET_EAC_USER_ERROR = "GET_EAC_USER_ERROR";

export const ADD_EAC_USER_REQUEST = "ADD_EAC_USER_REQUEST";
export const ADD_EAC_USER_SUCCESS = "ADD_EAC_USER_SUCCESS";
export const ADD_EAC_USER_ERROR = "ADD_EAC_USER_ERROR";

export const UPDATE_EAC_USER_REQUEST = "UPDATE_EAC_USER_REQUEST";
export const UPDATE_EAC_USER_SUCCESS = "UPDATE_EAC_USER_SUCCESS";
export const UPDATE_EAC_USER_ERROR = "UPDATE_EAC_USER_ERROR";
